import { render, staticRenderFns } from "./TempSpuShopIdsField.vue?vue&type=template&id=04d83f14&scoped=true"
import script from "./TempSpuShopIdsField.vue?vue&type=script&lang=ts"
export * from "./TempSpuShopIdsField.vue?vue&type=script&lang=ts"
import style0 from "./TempSpuShopIdsField.vue?vue&type=style&index=0&id=04d83f14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d83f14",
  null
  
)

export default component.exports